import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import styled from '@emotion/styled';
import LoadingSpinner from '../LoadingSpinner';

interface chapitre {
  chapitre_name: string;
  start_time?: number;
  end_time?: number;
}

interface VideoLink {
  ID: string;
  Lien: string;
  State: string;
}

const ChapterButtonGrid = styled.div`
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  gap: 20px;
  justify-content: center;
  justify-items: center;
`;

const Table = styled.table`
    width: 80%;
    margin: 20px auto;
    border-collapse: collapse;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  `;

  const Th = styled.th`
    padding: 12px;
    background-color: #007bff;
    color: white;
    border: 1px solid #ddd;
  `;

  const Td = styled.td`
    padding: 12px;
    border: 1px solid #ddd;
    text-align: center;
  `;

  const Tr = styled.tr`
    &:nth-of-type(even) {
      background-color: #f9f9f9;
    }
    &:hover {
      background-color: #f1f1f1;
    }
  `;

  const RemoveButton = styled.button`
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    cursor: pointer;
    font-size: 16px;
    line-height: 0;
    justify-content: center;
    align-items: center;
    &:hover {
      background-color: #ff7875;
    }
`;

const ScrappingScenario: React.FC = () => {

  const plageStart = localStorage.getItem('plageStart');
  const plageEnd = localStorage.getItem('plageEnd');
  const userLocalName = localStorage.getItem('username');
  
  const [videosLinks, setVideosLinks] = useState<VideoLink[]>([]);
  const [index, setIndex] = useState<number>(0);
  const [actualVideo, setActualVideo] = useState<string>();
  const [isActualVideo, setIsActualVideo] = useState<boolean>(false);

  const [inputValue, setInputValue] = useState('');

  const [allChapitre, setAllChapitre] = useState<chapitre[]>([]);

  const intro_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Intro.png`; 
  const caresse_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Petting.png`; 
  const sixNine_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_69.png`; 
  const andromaque_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Gemini.png`;
  const bateauIvre_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Captain.png`;
  const branletteEspagnole_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Titjob.png`;
  const cowgirl_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Cowgirl.png`;
  const chaiseBascule_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Reverse Cowgirl.png`;
  const anulingus_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Rimjob.png`;
  const ejaculation_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Cumshot.png`;
  const cunnilingus_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Pussy Licking.png`;
  const hommeDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Barbell.png`;
  const levrette_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Doggystyle.png`;
  const levretteDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Standing Doggystyle.png`;
  const masturbation_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Masturbation.png`;
  const leClou_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Piledriver.png`;
  const petiteCuilleres_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Spoon.png`;
  const pipe_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Blowjob.png`;
  const unionElephant_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Boat.png`;
  const missionary_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Missionary.png`;
  const missionaryDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Keeper.png`;
  const eagle_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Eagle.png`;
  const grasshopper_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Grasshopper.png`;
  const hommePorte_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Column.png`;
  const slowDance_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Slow Dance.png`;
  const vis_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Screw.png`;
  const placeConfort_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Comfortable Place.png`;

  const fetchVideos = async () => {
    console.log("Start :", plageStart);
    console.log("End :", plageEnd);
    try {
      if(plageStart && plageEnd) {
        const response = await axios.get(`https://foodybrain.com/api/ANTIMUS/get_scrapping_videos`, {
          params: {
            plageStart,
            plageEnd,
          },
        });
  
        setVideosLinks(response.data); 
        console.log(response.data);
      }
    } catch (err) {
      console.error("Error API :", err);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, [plageStart, plageEnd]);

  useEffect(() => {
    if(videosLinks.length > 0 && videosLinks[index]) {
      setActualVideo(`https://foodybrain.com/videos/video_${videosLinks[index].ID}.mp4`);
      setIsActualVideo(true);
    } else {
      setActualVideo('');
    }
  },[videosLinks, index]);

  const [clickedImages, setClickedImages] = useState<{ [key: string]: boolean }>({});

  const handleImageClick = (name: string) => {
    handleImgClick(name);
  
    setClickedImages((prev) => ({
      ...prev,
      [name]: true
    }));
  
    setTimeout(() => {
      setClickedImages((prev) => ({
        ...prev,
        [name]: false
      }));
    }, 150);
  };

  const handleImgClick = (name: string) => {
    setAllChapitre((prevChapitres) => {
      // Rechercher le premier chapitre sans `end_time`
      const indexSansEndTime = prevChapitres.findIndex(chap => chap.end_time === undefined);

      // Si un chapitre sans `end_time` est trouvé, le remplacer par le nouveau `chapitre_name`
      if (indexSansEndTime !== -1) {
        const newChapitres = [...prevChapitres];
        newChapitres[indexSansEndTime] = {
          ...newChapitres[indexSansEndTime],
          chapitre_name: name,  // Remplacer le nom du chapitre
        };
        return newChapitres;
      }

      // Si tous les chapitres ont un `end_time` défini, ajouter un nouveau chapitre
      const newChapitre: chapitre = {
        chapitre_name: name,
      };
      return [...prevChapitres, newChapitre];
    });
  };

const handleStartButton = () => {
  // Vérifie si le dernier élément de allChapitre existe
  setAllChapitre((prevChapitres) => {
  // Si la liste est vide, on ne fait rien
  if (prevChapitres.length === 0) return prevChapitres;

  // Clone de la liste des chapitres pour éviter de modifier directement l'état précédent
  const updatedChapitres = [...prevChapitres];

  // Récupérer le dernier chapitre
  const lastChapitreIndex = updatedChapitres.length - 1;

  // Définir le `start_time` du dernier chapitre en utilisant `videoRef.current?.currentTime`
  updatedChapitres[lastChapitreIndex] = {
    ...updatedChapitres[lastChapitreIndex],
    start_time: videoRef.current ? Math.floor(videoRef.current.currentTime) : 0,
  };

  return updatedChapitres;
  });
};

const handleEndButton = () => {
  // Vérifie si le dernier élément de allChapitre existe
  setAllChapitre((prevChapitres) => {
  // Si la liste est vide, on ne fait rien
  if (prevChapitres.length === 0) return prevChapitres;

  // Clone de la liste des chapitres pour éviter de modifier directement l'état précédent
  const updatedChapitres = [...prevChapitres];

  // Récupérer le dernier chapitre
  const lastChapitreIndex = updatedChapitres.length - 1;

  // Définir le `start_time` du dernier chapitre en utilisant `videoRef.current?.currentTime`
  updatedChapitres[lastChapitreIndex] = {
    ...updatedChapitres[lastChapitreIndex],
    end_time: videoRef.current ? Math.floor(videoRef.current.currentTime) : 0,
  };

  return updatedChapitres;
  });
};

// Fonction pour gérer la sauvegarde des chapitres
const saveChapitres = async (idVideo: string) => {
  if (idVideo === '' || allChapitre.length === 0) {
    alert('You can\'t save 0 chapter for the video. If the video is invalid please flag it');
    return;
  }

  try {
    // Appel à l'API pour sauvegarder les chapitres
    const response = await axios.post('https://foodybrain.com/api/ANTIMUS/save_chapitres', {
      id_video: idVideo,
      username: userLocalName,
      chapitres: allChapitre,
    });

    alert('Chapters successfully saved !');
  } catch (error) {
    console.error('API error :', error);
    alert('Error saving chapters. Please contact the admin.');
  }
};

const handleDoneButton = () => {
  if(allChapitre.length > 0) {
      saveChapitres(videosLinks[index].ID);

      setAllChapitre([]);

      const newIndex = index+1;
      setIndex(newIndex);
    }
};

// Fonction pour gérer la sauvegarde des chapitres
const flagVideo = async (idVideo: string, commentaire: string) => {
  let APIcomment;
  if(commentaire === '') {
    APIcomment = "Regular Flag Comment"
  } else {
    APIcomment = commentaire;
  }

  if (idVideo === '') {
    alert('Problem to flag the video. Please contact the admin.');
    return;
  }

  try {
    // Appel à l'API pour sauvegarder les chapitres
    const response = await axios.post('https://foodybrain.com/api/ANTIMUS/flag_video', {
      id_video: idVideo,
      comment: APIcomment
    });

    alert('Video flag successfully !');
  } catch (error) {
    console.error('Flag error :', error);
    alert('Flag error. Please contact the admin.');
  }
};

const [flagComment, setFlagComment] = useState<string>("");

const handleFlagButton = () => {
    flagVideo(videosLinks[index].ID, flagComment);
    setAllChapitre([]);
    setFlagComment("");

    const newIndex = index+1;
    setIndex(newIndex);
};

// Utiliser useEffect pour recharger la vidéo lorsqu'actualVideo change
useEffect(() => {
  if (videoRef.current && actualVideo) {
    // Recharger la vidéo avec la nouvelle source
    videoRef.current.pause();
    videoRef.current.load();
    videoRef.current.play();
  }
}, [actualVideo]);

const handleRemoveChapter = (index: number) => {
  setAllChapitre((prevChapitres) => prevChapitres.filter((_, i) => i !== index));
};

const [videoTime, setVideoTime] = useState<number>(0);
const videoRef = useRef<HTMLVideoElement | null>(null);

const handleEditTime = (type: string, nb:number) => {
  if(videoRef.current) {
    let currentTime = Math.floor(videoRef.current.currentTime);
    if(type === "plus") {
      videoRef.current.currentTime = currentTime + nb;;
    } else if (type === "moins") {
      videoRef.current.currentTime = Math.max(0, currentTime - nb);
    }
  }
};

useEffect(() => {
  const videoElement = videoRef.current;

    // Fonction pour mettre à jour le temps de la vidéo
    const updateTime = () => {
      if(videoElement) {
        setVideoTime(Math.floor(videoElement.currentTime));
      }
    };

    // Ajouter l'écouteur d'événement `timeupdate`
    if (videoElement) {
      videoElement.addEventListener('timeupdate', updateTime);
    }
  
  // Nettoyage de l'écouteur d'événement lorsque le composant est démonté
  return () => {
    if (videoElement) {
      videoElement.removeEventListener('timeupdate', updateTime);
    }
  };
}, [actualVideo]);

  return (
    <div style={{ padding: '20px', textAlign: 'center', backgroundColor: '#D3D3D3', minHeight: '100vh'}}>
      {!videosLinks[index] ? (
        <p>You have finished timestamping your range of video.</p>
      ) : (
        <>
        {isActualVideo ? (
          <>
          <div style={{ marginTop: '20px' }}>
          <button
            onClick={handleFlagButton}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              borderRadius: '5px',
              backgroundColor: '#ff3d3d',
              color: 'white',
              border: 'none',
              cursor: videosLinks[index] ? 'pointer' : 'not-allowed', // Changer le curseur si désactivé
              opacity: videosLinks[index] ? 1 : 0.6  // Rendre le bouton plus transparent s'il est désactivé
            }}
            disabled={!videosLinks[index]}
          >
            Flag the video
          </button>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
          <label htmlFor="flag-comment" style={{ marginRight: '5px' }}>Flag Comment:</label>
            <textarea
              id="flag-comment"
              value={flagComment}  // État pour stocker la valeur du commentaire
              onChange={(e) => setFlagComment(e.target.value)}  // Mettre à jour l'état lors de la saisie
              placeholder="Enter your comment here"
              style={{
                width: '500px',
                height: '50px',
                padding: '10px',
                fontSize: '14px',
                borderRadius: '5px',
                border: '1px solid #ccc',
              }}
            />
          </div>

            <h2>Vidéo ID n°{videosLinks[index].ID} :</h2>
            <video ref={videoRef} controls width="600">
              <source src={actualVideo} type="video/mp4" />
              Your browser does not support video playback.
            </video>
          </div>

          <p>Current video time : {videoTime}</p>
          
          <button
            onClick={() => handleEditTime("moins", 30)}>-30 sec
          </button>
          <button
            onClick={() => handleEditTime("moins", 5)}>-5 sec
          </button>
          <button
            onClick={() => handleEditTime("moins", 1)}>-1 sec
          </button>
          <button
            onClick={() => handleEditTime("plus", 1)}>+1 sec
          </button>
          <button
            onClick={() => handleEditTime("plus", 5)}>+5 sec
          </button>
          <button
            onClick={() => handleEditTime("plus", 30)}>+30 sec
          </button>
         
        <p></p>
  
        <button
          onClick={handleStartButton}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            borderRadius: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            marginRight: "10px",
          }}
        >
          Start Time
        </button>
          
        <button
          onClick={handleEndButton}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            borderRadius: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          End Time
        </button>
        </>
        ) : (
          <LoadingSpinner />
        )}

      <ChapterButtonGrid>
      <div style={{ textAlign: 'center' }}>
        <img src={intro_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Intro"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Intro")}/>
        <p>Intro</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={caresse_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Petting"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Petting")}/>
        <p>Petting</p>
      </div>

      <div style={{ textAlign: 'center' }}>  
        <img src={masturbation_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Masturbation"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Masturbation")} />
        <p>Masturbation</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={pipe_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Blowjob"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Blowjob")} />
        <p>Blowjob</p>
      </div>

      <div style={{ textAlign: 'center' }}>  
        <img src={branletteEspagnole_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Titjob"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Titjob")} />
        <p>Titjob</p>
      </div>

      <div style={{ textAlign: 'center' }}>  
        <img src={cunnilingus_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Pussy Licking"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Pussy Licking")} />  
        <p>Pussy Licking</p>
      </div>

      <div style={{ textAlign: 'center' }}>    
        <img src={anulingus_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Rimjob"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Rimjob")} />        
        <p>Rimjob</p>
      </div>

      <div style={{ textAlign: 'center' }}>  
        <img src={sixNine_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["69"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("69")}/>
        <p>69</p>
      </div>

      <div style={{ textAlign: 'center' }}>    
        <img src={missionary_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Missionary"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Missionary")} />
        <p>Missionary</p>
      </div>

      <div style={{ textAlign: 'center' }}>  
        <img src={missionaryDebout_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Keeper"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Keeper")} />
        <p>Keeper</p>
      </div>

      <div style={{ textAlign: 'center' }}>  
        <img src={bateauIvre_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Captain"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Captain")} />
        <p>Captain</p>
      </div>

      <div style={{ textAlign: 'center' }}>  
        <img src={eagle_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Eagle"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Eagle")} />
        <p>Eagle</p>
      </div>  
      
      <div style={{ textAlign: 'center' }}>
        <img src={slowDance_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Slow Dance"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Slow Dance")} />
        <p>Slow Dance</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={petiteCuilleres_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Spoon"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Spoon")} />
        <p>Spoon</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={grasshopper_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Grasshopper"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Grasshopper")} />
        <p>Grasshopper</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={vis_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Screw"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Screw")} />
        <p>Screw</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={levrette_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Doggystyle"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Doggystyle")} />
        <p>Doggystyle</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={levretteDebout_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Standing Doggystyle"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Standing Doggystyle")} />
        <p>Standing Doggystyle</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={unionElephant_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Boat"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Boat")} />
        <p>Boat</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={placeConfort_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Comfortable Place"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Comfortable Place")} />
        <p>Comfortable Place</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={chaiseBascule_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Reverse Cowgirl"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Reverse Cowgirl")} />
        <p>Reverse Cowgirl</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={cowgirl_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Cowgirl"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Cowgirl")} />
        <p>Cowgirl</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={andromaque_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Gemini"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Gemini")} />
        <p>Gemini</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={hommeDebout_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Barbell"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Barbell")} />
        <p>Barbell</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={hommePorte_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Column"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Column")} />
        <p>Column</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={leClou_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Piledriver"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Piledriver")} />
        <p>Piledriver</p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <img src={ejaculation_Icon} style={{cursor: 'pointer', height: '100px', transform: clickedImages["Cumshot"] ? 'scale(0.9)' : 'scale(1)', transition: 'transform 0.2s ease'}} onClick={() => handleImageClick("Cumshot")} />
        <p>Cumshot</p>
      </div>
      </ChapterButtonGrid>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <input
        type="text"
        placeholder="Position name"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        style={{ marginLeft: '10px', padding: '5px', fontSize: '16px', marginTop: '5px' }}
      />
      </div>

      <h1>Chapters list</h1>
      <Table>
        <thead>
          <tr>
            <Th>Chapters name</Th>
            <Th>Start time (sec)</Th>
            <Th>End time (sec)</Th>
            <Th>Remove line ?</Th>
          </tr>
        </thead>
        <tbody>
          {allChapitre.length > 0 ? (
            allChapitre.map((chap, index) => (
              <Tr key={index}>
                <Td>{chap.chapitre_name}</Td>
                <Td>{chap.start_time}</Td>
                <Td>{chap.end_time}</Td>
                <Td>
                  <RemoveButton onClick={() => handleRemoveChapter(index)}>
                    &#x2715;
                  </RemoveButton>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={4}>0 chapter</Td>
            </Tr>
          )}
        </tbody>
      </Table>

      <button
        onClick={handleDoneButton}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          borderRadius: '5px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          cursor: videosLinks[index] ? 'pointer' : 'not-allowed', // Changer le curseur si désactivé
          opacity: videosLinks[index] ? 1 : 0.6  // Rendre le bouton plus transparent s'il est désactivé
        }}
        disabled={!videosLinks[index]}
      >
        Next Timestamp Video
      </button>
    </>
    )}
    </div>
  );
};

export default ScrappingScenario;
